import { motion } from 'framer-motion';
import { useInView } from '../../../hooks/useInView';
import { Link } from 'react-router-dom';

const ContactSection = () => {
  const { ref, isInView } = useInView({ threshold: 0.3 });

  return (
    <section 
      id="contact"
      ref={ref} 
      className="relative min-h-[200px] flex items-center justify-center overflow-hidden py-12"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/15e52e1e2f53900b0cc6477241541a3c.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-darkgray/60 via-darkgray/40 to-darkgray/60" />

      <div className="relative z-10 px-8 lg:px-16 max-w-7xl mx-auto w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8 }}
          >
            <h2 className="font-serif text-5xl lg:text-6xl text-white mb-4 lowercase tracking-wide">
              Contact
            </h2>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-right"
          >
            <p className="font-sans text-lg text-white mb-6 leading-relaxed">
              まずはお気軽に<br />ご相談ください
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="mt-8"
        >
          <Link
            to="/contact"
            className="inline-flex items-center gap-4 px-10 py-4 bg-white text-darkgray rounded-full font-sans text-sm tracking-wide cursor-pointer transition-all duration-300 hover:bg-lightgray group"
          >
            お問い合わせ
            <div className="w-10 h-10 rounded-full bg-darkgray flex items-center justify-center group-hover:bg-sage transition-colors duration-300">
              <i className="ri-arrow-right-line text-white"></i>
            </div>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactSection;
